import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	spotlightHeading: {
		id: 'spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.performance-and-scale-menu.spotlight.spotlight-heading',
		defaultMessage: 'Clean out unused projects',
		description:
			'Heading for the spotlight prompting users to go to the Project menu item to clean up their instance data',
	},
	spotlightDescription: {
		id: 'spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.performance-and-scale-menu.spotlight.spotlight-description',
		defaultMessage:
			'Quickly remove inactive or empty projects to improve your site’s performance. ',
		description:
			'Description for the spotlight prompting users to go to the Project menu item to clean up their instance data',
	},
	spotlightAction: {
		id: 'spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.performance-and-scale-menu.spotlight.spotlight-action',
		defaultMessage: 'Ok',
		description: 'Action button for the spotlight section to dismiss spotlight',
	},
});
